/* Purpose: Generic Error page
 * Props: statusCode (str or int) --optional
 *        message (str) --optional
 *        error (str) --optional
 *        stackTrace (str) --optional
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React from "react";
import { Accordion, Container, Alert } from "react-bootstrap";
import SloganHeader from "./SloganHeader";

const Error = (props) => {
    const statusCode = props.statusCode || 500;
    const message = props.message || "An error occured."
    const error = props.error || "Something went wrong while trying to complete the requested task. Error details unavailable."
    const stackTrace = props.stackTrace || "Stack Trace Unavailable."


    return (
        <div className="align-items-center text-center ms-auto">
            <SloganHeader />
            <Container>
                <Alert variant = "danger" className="text-align-center m-4"><h1>{statusCode}  ERROR</h1></Alert>
                <h2>{message}</h2>
                <p>If you mistakenly got this message, please try refreshing the page or going back a step in your browser history. <br />
                    If the error persists, please email the complete error details to info@iskamortgage.com.</p>

                <Accordion size = "sm" className="m-3">
                    <Accordion.Item variant = "danger" eventKey="0">
                        <Accordion.Header className="d-block text-center"><p className="ms-auto d-block  text-center">Error Details</p></Accordion.Header>
                        <Accordion.Body className="text-start">
                            <h3>{error}</h3>
                            <p>Status Code: {statusCode}</p>
                            <p>{stackTrace}</p>
                        </Accordion.Body>
                    </Accordion.Item>
                    
                </Accordion>
            </Container>
            
        </div>
    );
};

export default Error;
